export { default } from './CarrosEletricosPremioMobilidadeResultado';
